/*! lyd-teklabs-i18n 2026-09-23b — German Free Gift copy + strip Tek Labs branding */
(function () {
  var EMBED_DE = {"version": "2.0.0", "header": {"title": "Gratis-Geschenk", "subtitle": "{{offer_ready_to_claim}} von {{offer_counts}} verfügbar"}, "default": {"list_header": {"title": "Gratis-Geschenk", "subtitle": "{{offer_ready_to_claim}} von {{offer_counts}} verfügbar"}, "header": {"quantity_heading": "Kaufe mindestens {{condition}} für dein Geschenk", "amount_heading": "Kaufe für mindestens {{condition}} für dein Geschenk", "badge": "Gratis-Zugabe"}, "upsell_message": {"not_eligible": "Kaufe noch {{remain}}, um das Geschenk freizuschalten", "eligible": "Freigeschaltet – jetzt auswählen", "claimed": "Geschenk beansprucht"}, "main_offer": {"free_text": "GRATIS", "select_button": "Auswählen", "unselect_button": "Auswahl aufheben", "claim_button": "Beanspruchen", "countdown_timer": "Noch {{timer}}"}, "selection_hint": {"not_eligible": "Bis zu {{gift_number}} Geschenke auswählen", "eligible": "Ausgewählt: {{gift_selected}}/{{gift_number}}", "claimed": "Beansprucht: {{gift_number}}/{{gift_number}}"}, "toast": {"err_when_claim": "Fehler. Bitte erneut versuchen.", "not_choose_enough_gift": "Voraussetzung noch nicht erfüllt."}, "caption": {"claim_up_to": "Bis zu {{gift_number}} Geschenke auswählen", "claimed": "Geschenk beansprucht", "auto_added": ""}}};
  function patch(data) {
    if (!data || typeof data !== "object") return data;
    data.showTrademark = false;
    data.translations = {
      embed: {
        de: EMBED_DE,
        "de-DE": EMBED_DE
      }
    };
    return data;
  }
  function stripBrand() {
    document.querySelectorAll(".salepify-popup__trademark").forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll(".salepify-embed-widget__caption").forEach(function (el) {
      var t = (el.textContent || "").trim().toLowerCase();
      if (!t || t.indexOf("auto-added") !== -1 || t.indexOf("automatisch") !== -1) {
        el.remove();
      }
    });
  }
  var held = window.tlFreeGiftData;
  if (held) patch(held);
  try {
    Object.defineProperty(window, "tlFreeGiftData", {
      configurable: true,
      enumerable: true,
      get: function () { return held; },
      set: function (v) { held = patch(v); }
    });
  } catch (e) {
    if (window.tlFreeGiftData) patch(window.tlFreeGiftData);
  }
  var n = 0;
  var t = setInterval(function () {
    n += 1;
    if (window.tlFreeGiftData) patch(window.tlFreeGiftData);
    stripBrand();
    if (n > 240) clearInterval(t);
  }, 50);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", stripBrand);
  } else {
    stripBrand();
  }
  try {
    var mo = new MutationObserver(stripBrand);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  } catch (e2) {}
})();
